import React from 'react';
import PropTypes from 'prop-types';

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="mb-8 border-b border-border">
      <nav className="-mb-px flex space-x-8">
        {tabs.map(tab => (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            className={`pb-3 px-1 border-b-2 font-medium text-sm capitalize ${
              activeTab === tab
                ? 'border-primary text-primary'
                : 'border-transparent text-muted hover:text-text'
            }`}
          >
            {tab}
          </button>
        ))}
      </nav>
    </div>
  );
};

TabNavigation.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default TabNavigation;
